import { useEffect, useState } from 'react';
export const Suripanta = ({ children, parent, type, location, attributes, lazyLoad }) => {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        window.addEventListener('load', () => {
            setLoaded(true);
        });
        return window.addEventListener('load', () => {
            setLoaded(false);
        });
    }, []);
    if (lazyLoad && !loaded)
        return null;
    const element = document.querySelector(parent);
    if (!element) {
        return null;
    }
    const s = document.createElement(type);
    if (children)
        s.innerHTML = children;
    if (attributes)
        attributes.forEach(attribute => {
            s.setAttribute(attribute.name, attribute.value);
        });
    if (location === 'start') {
        element.prepend(s);
    }
    else {
        element.appendChild(s);
    }
    return null;
};
